import React, { useEffect } from "react";
import styles from "./accounting.module.css";
import logo from "../../img/nobat-logo.png";
import { useState } from "react";
import { Icon, Radio, Button, message, Skeleton } from "antd";
import { useRef } from "react";
import axios from "axios";

const Accounting = (props) => {
  const pincode = props.match.params.pincode;
  const startDateRef = useRef();
  const endDateRef = useRef();

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [format, setFormat] = useState(1);
  const [options, setOptions] = useState([]);
  const [loading, setloading] = useState(false);

  useEffect(() => {
    getOptionsAction();
  }, []);

  const getOptionsAction = async () => {
    setloading(true);
    const formData = new FormData();
    formData.append("pincode", pincode);
    let config = {
      method: "post",
      url: window.server + "/accounting/plugin/list",
      data: formData,
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      let response = await axios(config);
      let res = response.data;
      setOptions(res);
      setloading(false);
    } catch (error) {
      setloading(false);
      console.log(error);
    }
  };

  const getExcelAction = () => {
    if (startDate.length == 0) {
      message.error("تاریخ شروع را وارد کنید");
      return;
    }
    if (endDate.length == 0) {
      message.error("تاریخ پایان را وارد کنید");
      return;
    }

    let url = `${window.server}/accounting/download?start_date=${startDate}&end_date=${endDate}&format=${format}&pincode=${pincode}`;
    window.open(url, "_blank");
  };

  const getCustomerListAction = () => {
    const rand = Math.random();

    let url = `${window.server}/accounting/customer-list?pincode=${pincode}&rand=${rand}`;
    window.open(url, "_blank");
  };

  const radioStyle = {
    display: "block",
    height: "30px",
    lineHeight: "30px",
  };

  return (
    <div className={styles.main}>
      <div className={styles.box}>
        <img src={logo} />
        <div className={styles.date_box}>
          <div className={styles.input_date_box}>
            <Icon type="calendar" />
            <input
              ref={startDateRef}
              type="text"
              placeholder="تاریخ شروع : ۱۴۰۱/۱۲/۱"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div className={styles.input_date_box}>
            <Icon type="calendar" />
            <input
              ref={endDateRef}
              type="text"
              placeholder="تاریخ پایان : ۱۴۰۱/۱۲/۱۵"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>
        <div className={styles.radio_box}>
          {loading ? (
            <Skeleton active />
          ) : (
            <Radio.Group
              value={format}
              onChange={(e) => setFormat(e.target.value)}
            >
              {options.map((option) => {
                return (
                  <Radio
                    key={option.value}
                    value={option.value}
                    style={radioStyle}
                  >
                    {option.text}
                  </Radio>
                );
              })}
            </Radio.Group>
          )}
        </div>
        <div className={styles.btn_box}>
          <Button
            className="mt-3"
            type="primary"
            onClick={() => getExcelAction()}
          >
            دریافت فایل
          </Button>
          <Button
            className="my-3"
            type="primary"
            onClick={() => getCustomerListAction()}
          >
            لیست همه مشتریان
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Accounting;
